import React from "react";

const CommanderSelectionModal = ({
  isOpen,
  sideLabel,
  currentProfile,
  profiles = [],
  isLoading = false,
  searchQuery = "",
  onSearchChange,
  onSelectProfile,
  onCreateProfile,
  onOpenProfileManager,
  onClose,
  isBusy = false,
}) => {
  if (!isOpen) return null;

  const isCapturedCurrent = (profile) => String(profile?.sourceType || profile?.profileKind || "") === "captured_current"
    || profile?.isCapturedCurrent === true;
  const sourceLabel = (profile) => (isCapturedCurrent(profile) ? "Captured current" : "Manual profile");

  const normalizedQuery = String(searchQuery || "").trim().toLowerCase();
  const filteredProfiles = !normalizedQuery
    ? profiles
    : profiles.filter((profile) => {
      const name = String(profile?.name || "").toLowerCase();
      const linkedCommanderName = String(profile?.linkedCommanderName || "").toLowerCase();
      return name.includes(normalizedQuery) || linkedCommanderName.includes(normalizedQuery);
    });

  return (
    <div className="commander-modal-overlay" onClick={onClose} role="presentation">
      <div className="commander-modal" onClick={(event) => event.stopPropagation()} role="dialog" aria-modal="true">
        <div className="commander-modal-head">
          <h3>Change {sideLabel} Commander</h3>
          <button type="button" onClick={onClose}>Close</button>
        </div>

        <div className="commander-modal-current">
          <strong>Current:</strong> {currentProfile?.name || "None selected"}
          <div>Source: {currentProfile ? sourceLabel(currentProfile) : "None"}</div>
          <div>Linked Commander: {currentProfile?.linkedCommanderName || "None"}</div>
        </div>

        <div className="commander-modal-toolbar">
          <input
            type="text"
            value={searchQuery}
            onChange={(event) => onSearchChange?.(event.target.value)}
            placeholder="Search profile or linked commander..."
          />
          <button type="button" onClick={onCreateProfile} disabled={isBusy}>
            Create New Profile
          </button>
          <button type="button" onClick={onOpenProfileManager} disabled={isBusy || isCapturedCurrent(currentProfile)}>
            Open Profile Manager
          </button>
        </div>

        <div className="commander-modal-list">
          {isLoading ? (
            <div className="commander-modal-empty">Loading profiles...</div>
          ) : filteredProfiles.length === 0 ? (
            <div className="commander-modal-empty">No profiles found.</div>
          ) : filteredProfiles.map((profile) => (
            <button
              key={profile._id}
              type="button"
              className={`commander-modal-row ${String(profile?._id) === String(currentProfile?._id) ? "selected" : ""}`}
              onClick={() => onSelectProfile?.(profile)}
              disabled={isBusy}
            >
              <div className="commander-modal-row-title">{profile?.name || "Unnamed Profile"}</div>
              <div className="commander-modal-row-sub">
                {sourceLabel(profile)} | Linked: {profile?.linkedCommanderName || "None"} | BP {Number(profile?.powerSummary?.battlePower || 0).toLocaleString()}
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CommanderSelectionModal;
